/*
 * @Description: 直播课堂
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/pcHome.vue'
const liveClassroomRouter: Array<RouteRecordRaw> = [
    {
        path: '/academicAffairs',
        component: Layout,
        redirect: '/academicAffairs/importData',
        children: [
            {
                path: 'importDataEduc',
                component: () => import(/* webpackChunkName: "ImportDataEduc" */ '@/views/academicAffairs/importData/index.vue'),
                name: 'ImportDataEduc',
                meta: { title: '教务数据导入' },
            },
            {
                path: 'facultyManageEduc',
                component: () => import(/* webpackChunkName: "FacultyManageEduc" */ '@/views/academicAffairs/facultyManage/index.vue'),
                name: 'FacultyManageEduc',
                meta: { title: '院系管理' },
            },
            {
                path: 'administrativeEduc',
                component: () => import(/* webpackChunkName: "Administrative" */ '@/views/academicAffairs/administrative/index.vue'),
                name: 'Administrative',
                meta: { title: '行政班管理' },
                redirect: '/academicAffairs/administrativeEduc/administrativeList',
                children:[
                    {
                        path: 'administrativeList',
                        component: () => import(/* webpackChunkName: "AdministrativeList" */ '@/views/academicAffairs/administrative/list.vue'),
                        name: 'AdministrativeList',
                        meta: { title: '' },
                    },
                    {
                        path: 'administrativeDetail',
                        component: () => import(/* webpackChunkName: "AdministrativeDetail" */ '@/views/academicAffairs/administrative/detail.vue'),
                        name: 'AdministrativeDetail',
                        meta: { title: '学生列表' },
                    }
                ]
            },
            {
                path: 'teacherManageEduc',
                component: () => import(/* webpackChunkName: "TeacherManage" */ '@/views/academicAffairs/teacherManage/index.vue'),
                name: 'TeacherManage',
                meta: { title: '' },
                redirect: '/academicAffairs/teacherManageEduc/teacherManageList',
                children:[
                    {
                        path: 'teacherManageList',
                        component: () => import(/* webpackChunkName: "TeacherManageList" */ '@/views/academicAffairs/teacherManage/list.vue'),
                        name: 'TeacherManageList',
                        meta: { title: '老师管理' },
                    },
                    {
                        path: 'teacherManageDetail',
                        component: () => import(/* webpackChunkName: "TeacherManageDetail" */ '@/views/academicAffairs/teacherManage/detail.vue'),
                        name: 'TeacherManageDetail',
                        meta: { title: '课堂统计' },
                    }
                ]
            },
            {
                path: 'studentManageEduc',
                component: () => import(/* webpackChunkName: "StudentManage" */ '@/views/academicAffairs/studentManage/index.vue'),
                name: 'StudentManage',
                meta: { title: '' },
                redirect: '/academicAffairs/studentManageEduc/studentManageList',
                children:[
                    {
                        path: 'studentManageList',
                        component: () => import(/* webpackChunkName: "StudentManageList" */ '@/views/academicAffairs/studentManage/list.vue'),
                        name: 'StudentManageList',
                        meta: { title: '学生管理' },
                    },
                    {
                        path: 'studentManageDetail',
                        component: () => import(/* webpackChunkName: "StudentManageDetail" */ '@/views/academicAffairs/studentManage/detail.vue'),
                        name: 'StudentManageDetail',
                        meta: { title: '课堂统计' },
                    },
                    {
                        path: 'studentManageInfo',
                        component: () => import(/* webpackChunkName: "StudentManageInfo" */ '@/views/academicAffairs/studentManage/info.vue'),
                        name: 'StudentManageInfo',
                        meta: { title: '学生详情' },
                    }
                ]
            },
            {
                path: 'courseManageEduc',
                component: () => import(/* webpackChunkName: "CourseManageEduc" */ '@/views/academicAffairs/courseManage/index.vue'),
                name: 'CourseManageEduc',
                redirect: '/academicAffairs/courseManageEduc/courseListEduc',
                meta: { title: '课程管理' },
                children: [
                    {
                        path: 'courseListEduc',
                        component: () => import(/* webpackChunkName: "CourseListEduc" */ '@/views/academicAffairs/courseManage/courseList.vue'),
                        name: 'CourseListEduc',
                        meta: { title: '课程列表' }
                    },
                    {
                        path: 'courseStudentListEduc',
                        component: () => import(/* webpackChunkName: "CourseStudentListEduc" */ '@/views/academicAffairs/courseManage/courseStudentList.vue'),
                        name: 'CourseStudentListEduc',
                        meta: { title: '课程学生列表' }
                    },
                    {
                        path: 'courseStatisticsEduc',
                        component: () => import(/* webpackChunkName: "CourseStatisticsEduc" */ '@/views/academicAffairs/courseManage/courseStatistics.vue'),
                        name: 'CourseStatisticsEduc',
                        meta: { title: '课程统计' }
                    },
                ]

            },
            {
                path: 'semesterManageEduc',
                component: () => import(/* webpackChunkName: "SemesterManageEduc" */ '@/views/academicAffairs/semesterManage/index.vue'),
                name: 'SemesterManageEduc',
                meta: { title: '学期管理' },
            },

        ]
    }
]

export default liveClassroomRouter
